import FeatureTable from "@arcgis/core/widgets/FeatureTable";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

export const configureFeatureTable = (view, activeHazardLayer) => {
  const container = document.getElementById("feature-table");
  // clear previous FeatureTable if any
  container.innerHTML = "";

  const featureTable = new FeatureTable({
    view,
    layer: activeHazardLayer,
    tableTemplate: {
      columnTemplates: [
        { type: "field", fieldName: "hazard_label", label: "Hazard Label", visible: true },
        { type: "field", fieldName: "status", label: "Status", visible: true },
        { type: "field", fieldName: "latitude", label: "Latitude", visible: true },
        { type: "field", fieldName: "longitude", label: "Longitude", visible: true },
        { type: "field", fieldName: "proximity_to_area", label: "Proximity to AoI (Km)", visible: true },
        { type: "field", fieldName: "aoi_name", label: "AoI", visible: true },
      ],
    },
    container,
    label: "Hazards",
  });

  view.whenLayerView(activeHazardLayer).then((layerView) => {
    reactiveUtils.watch(
      () => layerView.updating,
      (updating) => {
        if (!updating) {
          featureTable.refresh();

          // Filter table to current extent
          reactiveUtils.when(
            () => view.stationary,
            () => {
              featureTable.filterGeometry = view.extent;
            },
            { initial: true }
          );

          // Handle click interaction: select or unselect
          view.on("immediate-click", async (event) => {
            const response = await view.hitTest(event);

            const candidate = response.results.find((result) => {
              return result.graphic && result.graphic.layer === activeHazardLayer;
            });

            if (candidate) {
              const objectId = candidate.graphic.getObjectId();

              // Only select if it's a new feature
              featureTable.highlightIds.removeAll();
              featureTable.highlightIds.add(objectId);
            } else {
              featureTable.highlightIds.removeAll();
            }
          });
        }
      }
    );
  });
};